import { companyReportsAxiosInstance } from './axiosInstance.service';

export const getNetworkIntelligence = (
  searchField: 'organizationName' | 'fullName',
  name: string,
  countryISO: string,
  dateOfBirth: string,
) => {
  return companyReportsAxiosInstance.get(
    '/network-analyst',
    {
      params: {
        searchField,
        name,
        countryISO,
        dateOfBirth,
      },
    }
  );
};
